import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/plugins/axios'
import {getItem} from '@/helpers/persistantStorage'
import customErrors from '@/store/error'

import auth from '@/store/modules/auth'
import client from '@/store/modules/client'
import dictionary from '@/store/modules/dictionary'
import target from '@/store/modules/target'
import file from '@/store/modules/file'
import creative from '@/store/modules/creative'
import notification from '@/store/modules/notification'
import company from '@/store/modules/company'
import notUsedCreative from '@/store/modules/notUsedCreative'
import rule from '@/store/modules/rule'
import finance from '@/store/modules/finance'
import rate from '@/store/modules/rate'
import security from '@/store/modules/security'
import statistic from '@/store/modules/statistic'
import dashboard from '@/store/modules/dashboard'
import integration from '@/store/modules/integration'
import filters from '@/store/modules/filters'
import audience from '@/store/modules/audience'
import segment from '@/store/modules/segment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    toastQueue: [],
    isCheckLocale: true,
    locale: getItem('nt_system_language') || 'en',
  },
  mutations: {
    CHANGE_LOCALE(state, {check, locale}) {
      state.isCheckLocale = check
      state.locale = locale
    },
    ADD_TOAST_QUEUE(state, payload) {
      state.toastQueue.push(payload)
    },
    REMOVE_CURRENT_TOAST(state) {
      state.toastQueue.shift()
    },
  },
  actions: {
    SHOW_TOAST_SUCCESS({commit}, message) {
      commit('ADD_TOAST_QUEUE', {
        message,
        color: 'green',
      })
    },
    SHOW_TOAST_INFO({commit}, message) {
      commit('ADD_TOAST_QUEUE', {
        message,
        color: 'orange darken-1',
      })
    },
    SHOW_TOAST_ERROR({commit}, message) {
      commit('ADD_TOAST_QUEUE', {
        message,
        color: 'red darken-1',
      })
    },
    CLOSE_TOAST({commit}) {
      commit('REMOVE_CURRENT_TOAST')
    },
    async GET_PUBLIC_INFO({commit, dispatch}, inn) {
      try {
        return await axios.get(`public/advertiser/${inn}`)
      } catch (err) {
        await customErrors(err, dispatch)
      }
    },
  },
  modules: {
    auth,
    client,
    dictionary,
    target,
    file,
    creative,
    notification,
    company,
    notUsedCreative,
    rule,
    finance,
    rate,
    security,
    statistic,
    dashboard,
    integration,
    filters,
    audience,
    segment,
  },
})
